import * as config from "../config"
import fetch from "isomorphic-fetch"
import getJamFilledCookie from "../getJamFilledCookie"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"

interface Result {
	// TODO: What is the shape of the returned JSON?
}

export default async function inviteToJam(
	JAM_ID: string,
	emails: string[],
	host: string,
): Promise<Result | void> {
	console.log(JAM_ID, emails)
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/invite`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
				body: JSON.stringify({ emails, host }),
			},
		)

		const json = await res.json()

		return json
	} catch (e) {
		console.log(e)
	}
}
